import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  Output,
  EventEmitter
} from '@angular/core';

export interface SectionCountersData {
  title: string;
  subtitle: string;
  img: string;
  counters: Array<{
    limit: number;
    scale: string;
    icon: string;
    description: string;
  }>;
  buttons: Array<{ color: string; title: string; url: string }>;
}

@Component({
  selector: 'fcp-section-counters',
  templateUrl: './section-counters.component.html',
  styleUrls: ['./section-counters.component.scss']
})
export class SectionCountersComponent {
  @Input() public sectionCounters: SectionCountersData;
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();

  @ViewChild('element') public elementRef: ElementRef;
  public canShow = false;

  @HostListener('window:scroll', ['$event']) public onWindowScroll(from?: any) {
    if (
      this.canShow === false &&
      this.isElementVisible(this.elementRef.nativeElement)
    ) {
      setTimeout(() => {
        this.canShow = true;
      }, 400);
    }
  }

  private isElementVisible(el: any): boolean {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top >= window.pageYOffset &&
      left >= window.pageXOffset &&
      top + height <= window.pageYOffset + window.innerHeight &&
      left + width <= window.pageXOffset + window.innerWidth
    );
  }

  public emitClick(btn: any): void {
    if (btn) {
      this.wasButtonClicked.emit(btn);
    }
  }
}
